import { render, staticRenderFns } from "./PayURedirect.vue?vue&type=template&id=723d5c49&scoped=true&"
import script from "./PayURedirect.vue?vue&type=script&lang=js&"
export * from "./PayURedirect.vue?vue&type=script&lang=js&"
import style0 from "./PayURedirect.vue?vue&type=style&index=0&id=723d5c49&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723d5c49",
  null
  
)

export default component.exports